// extracted by mini-css-extract-plugin
module.exports = {"layout":"profile-card_layout__4L_JU"};